// Check if dom is ready and loaded before running the script
$(document).ready(function () {
    setTimeout(() => {
        // Checks if featured_images is not defined and it is not empty and if we're on laptop or up
        if (
            typeof featured_images !== "undefined" &&
            featured_images.length > 0 &&
        $(window).width() >= 1024
        ) {
            // Selects all products on the collection page "nyheder/news"
            let numberOfproducts = $(".boost-pfs-filter-product-item").length;
            let counter = 0;
            $(".boost-pfs-filter-product-item").each(function (index, element) {
                counter++;

                let isFirstItem = index === 0;
                // If we have more products than featured images, we stop
                if (counter > featured_images.length) {
                return false;
                }
                // Get all classes on the element and remove product-specific class
                const classList = $(this)
                .attr("class")
                .split(/\s+/)
                .filter(function (item) {
                    return item.indexOf("boost-pfs-filter-product-item") === -1;
                });

                const currentFeaturedImage = featured_images[index];
                const imageUrl = currentFeaturedImage["image"];
                const imageLink = currentFeaturedImage["link"];

                let imageBanner = "";
                let attributes = "";

                if (!isFirstItem) {
                    attributes = 'loading="lazy"';
                }

                if (imageLink === "") {
                // Create the banner elements
                imageBanner = $(`
                            <div class="boost-pfs-custom__image-banner ${classList}">
                                <img ${attributes} src="${imageUrl}" />
                            </div>
                        `);
                } else {
                imageBanner = $(`
                            <div class="boost-pfs-custom__image-banner ${classList}">
                                <a href="${imageLink}">
                                    <img ${attributes} src="${imageUrl}" />
                                </a>
                            </div>
                        `);
                }

                const bannerIndexes = new Set();
                for (let i = 0; i < numberOfproducts; i++) {
                if (i === 0 || (i % 6 === 0 && i < numberOfproducts - 1)) {
                    bannerIndexes.add(i + 6);
                }
                }
                if (isFirstItem) {
                $(this).before(imageBanner);
                } else if (bannerIndexes.has(index)) {
                if (featured_images.length > 2) {
                    $(this).before(imageBanner, imageBanner);
                } else {
                    $(this).before(imageBanner);
                }
                }
            });
        }
        // Update the banner image max-height on resize to match product image height
        $(".boost-pfs-custom__image-banner").each(function () {
            let productImageHeight = $($(".boost-pfs-custom__image-banner").parent().find(".boost-pfs-filter-product-item")[0]).find('.boost-pfs-filter-product-item-main-image').height();
            $(this).find('img').css("max-height", productImageHeight);
        });
        
        
        // Adds resize listener that hides banner images below 1024px
        $(window).resize(function () {
            if ($(window).width() < 1024) {
                $(".boost-pfs-custom__image-banner").hide();
            } else {
                $(".boost-pfs-custom__image-banner").show();
            }

            // Update the banner image max-height on resize to match product image height
            $(".boost-pfs-custom__image-banner").each(function () {
                let productImageHeight = $($(".boost-pfs-custom__image-banner").parent().find(".boost-pfs-filter-product-item")[0]).find('.boost-pfs-filter-product-item-main-image').height();
                $(this).find('img').css("max-height", productImageHeight);
            });
        });
    
        // Function to render sizes for all products
        function renderProductSizes() {
            $(".boost-pfs-filter-product-item").each(function () {
                let sizesWrapper = $(this).find(".boost-pfs-filter-product-item__sizes");
                let imageWrapper = $(this).find(".boost-pfs-filter-product-item-image");
                
                // Remove any existing size overlay
                imageWrapper.find(".boost-pfs-size-overlay").remove();
                
                let sizes = sizesWrapper.data("available-sizes");
                if (typeof sizes !== 'undefined' && sizes !== "") {
                    sizes = sizes.split(',');

                    // Sort empty strings from the array
                    sizes = sizes.filter(function (el) {
                        return el != "";
                    });

                // If there are no sizes, don't create overlay
                if (sizes.length === 0) {
                    return;
                }

                // Separate available and sold out sizes
                let availableSizes = [];
                let soldOutSizes = [];
                
                for (let i = 0; i < sizes.length; i++) {
                    if (sizes[i] === "") continue;
                    
                    const isSoldOut = sizes[i].includes("s");
                    const size = sizes[i].replace("s", "");
                    
                    if (isSoldOut) {
                        soldOutSizes.push(size);
                    } else {
                        availableSizes.push(size);
                    }
                }

                // Only show available sizes for the logic
                if (availableSizes.length === 0) {
                    return;
                }

                // Convert sizes to numbers for proper sorting
                const numericSizes = availableSizes.map(size => {
                    // Handle different size formats (e.g., "34", "XS", "M", "L")
                    const numSize = parseInt(size);
                    return isNaN(numSize) ? size : numSize;
                }).sort((a, b) => {
                    // Sort numbers numerically, strings alphabetically
                    if (typeof a === 'number' && typeof b === 'number') {
                        return a - b;
                    }
                    return String(a).localeCompare(String(b));
                });

                // Build the size content
                let sizeContent = '';
                
                // Determine display logic based on available sizes count
                if (numericSizes.length <= 3) {
                    // Show specific sizes (3 or fewer)
                    sizeContent = numericSizes.map(size => `<span>${size}</span>`).join('');
                } else {
                    // Check if all sizes are in stock (no sold out sizes)
                    const allSizesInStock = soldOutSizes.length === 0;
                    
                    if (allSizesInStock) {
                        // Show range (lowest to highest) when all sizes are in stock
                        const lowest = numericSizes[0];
                        const highest = numericSizes[numericSizes.length - 1];
                        const sizesAvailableText = window.theme && window.theme.strings && window.theme.strings.products && window.theme.strings.products.inventory && window.theme.strings.products.inventory.sizes_available 
                            ? window.theme.strings.products.inventory.sizes_available 
                            : 'tilgængelig';
                        sizeContent = `<span>Str. ${lowest}-${highest} ${sizesAvailableText}</span>`;
                    } else {
                        // Show "Flere størrelser på lager" for other scenarios
                        const multipleSizesText = window.theme && window.theme.strings && window.theme.strings.products && window.theme.strings.products.inventory && window.theme.strings.products.inventory.multiple_sizes_available 
                            ? window.theme.strings.products.inventory.multiple_sizes_available 
                            : 'Flere størrelser på lager';
                        sizeContent = `<span>${multipleSizesText}</span>`;
                    }
                }

                // Create the overlay and append it to the image wrapper
                if (imageWrapper.length > 0 && sizeContent) {
                    imageWrapper.append(`<div class="boost-pfs-size-overlay">${sizeContent}</div>`);
                }
                }
            });
        }

        // Wait for Boost PFS to be available before hooking into it
        function hookIntoBoostPFS() {
            // Hook into Boost PFS afterRender callback to re-render sizes on pagination
            if (typeof ProductList !== 'undefined' && ProductList.prototype) {
                const originalAfterRender = ProductList.prototype.afterRender;
                if (originalAfterRender && !ProductList.prototype._boostPfsSizeHooked) {
                    ProductList.prototype.afterRender = function(data) {
                        // Call the original afterRender function
                        if (originalAfterRender) {
                            originalAfterRender.call(this, data);
                        }
                        
                        // Re-render product sizes after new products are loaded
                        setTimeout(() => {
                            renderProductSizes();
                        }, 100);
                    };
                    ProductList.prototype._boostPfsSizeHooked = true;
                }
            }

            // Also hook into Filter afterRender for filter changes
            if (typeof Filter !== 'undefined' && Filter.prototype) {
                const originalFilterAfterRender = Filter.prototype.afterRender;
                if (originalFilterAfterRender && !Filter.prototype._boostPfsSizeHooked) {
                    Filter.prototype.afterRender = function(data) {
                        // Call the original afterRender function
                        if (originalFilterAfterRender) {
                            originalFilterAfterRender.call(this, data);
                        }
                        
                        // Re-render product sizes after filter changes
                        setTimeout(() => {
                            renderProductSizes();
                        }, 100);
                    };
                    Filter.prototype._boostPfsSizeHooked = true;
                }
            }
        }

        // Try to hook immediately
        hookIntoBoostPFS();

        // On load, render available sizes for each product
        renderProductSizes();

        /**
         * Replace the default Boost PFS filter icon with a custom one
         */
        const customSVGArrow = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z" clip-rule="evenodd" /></svg>`;
        // $(".boost-pfs-filter-tree-desktop-button-icon svg").remove();

        // $(".boost-pfs-filter-tree-desktop-button-icon").append(customSVGArrow);
        $("boost-pfs-filter-toolbar-top-desktop-inner boost-pfs-filter-top-sorting-wrapper").append(customSVGArrow);
        $(".boost-pfs-filter-toolbar-top-mobile-inner .boost-pfs-filter-top-sorting-wrapper").append(customSVGArrow);


        /* Trigger Boost-pfs-offcanvas to close */
        $('.boost-pfs-filter__offcanvas-close').click( () => {
            $('.boost-pfs-filter-tree-desktop-button button').click();
        });

        // Try to hook again after a short delay to ensure Boost PFS is loaded
        setTimeout(() => {
            hookIntoBoostPFS();
        }, 500);
    }, 1000); // Compensate for boost loadtime
});
